import SEO from "@/components/SEO";

const DJ_IMAGE = "/alekz-dj.jpg";

export default function About() {
  return (
    <section
      className="relative min-h-screen pt-32 sm:pt-40 px-6 sm:px-10 lg:px-14 pb-24"
      data-testid="about-page"
    >
      <SEO
        path="/about"
        title="About"
        description="About ALEKZ (Alex Soto, Alekz Soto, Alexander Soto). A New York-based DJ, techno producer and creative. NYU graduate. Platinum Sound Studios, Formations."
      />
      <div className="max-w-6xl mx-auto">
        <h2
          className="font-display text-white leading-[0.95]"
          style={{ fontSize: "clamp(3rem, 9vw, 7rem)", letterSpacing: "-0.01em" }}
          data-testid="about-title"
        >
          About
        </h2>

        <div className="mt-10 h-px bg-[var(--hairline-strong)] line-grow" />

        {/* Composition: large cropped photo on the left, text overlapping on the right */}
        <div className="mt-16 relative md:min-h-[640px]">
          {/* Image — absolute on desktop so text can overlap */}
          <div
            data-testid="about-photo-wrap"
            className="relative md:absolute md:inset-y-0 md:left-0 md:w-[72%] lg:w-[68%] z-0 mb-10 md:mb-0"
          >
            <div
              className="relative w-full overflow-hidden"
              style={{ aspectRatio: "5 / 4" }}
            >
              <img
                src={DJ_IMAGE}
                alt="ALEKZ performing"
                data-testid="about-photo"
                draggable={false}
                className="absolute inset-0 w-full h-full object-cover fade-in"
                style={{
                  objectPosition: "50% 18%",
                  filter: "grayscale(100%) contrast(1.12) brightness(0.78)",
                  animationDelay: "0.15s",
                  maskImage:
                    "linear-gradient(to right, rgba(0,0,0,1) 0%, rgba(0,0,0,1) 40%, rgba(0,0,0,0.55) 72%, rgba(0,0,0,0.15) 90%, rgba(0,0,0,0) 100%)",
                  WebkitMaskImage:
                    "linear-gradient(to right, rgba(0,0,0,1) 0%, rgba(0,0,0,1) 40%, rgba(0,0,0,0.55) 72%, rgba(0,0,0,0.15) 90%, rgba(0,0,0,0) 100%)",
                }}
              />
              {/* Top + bottom soft fades so the photo bleeds into the page */}
              <div
                aria-hidden
                className="pointer-events-none absolute inset-0"
                style={{
                  background:
                    "linear-gradient(to bottom, rgba(0,0,0,0.55) 0%, rgba(0,0,0,0) 18%, rgba(0,0,0,0) 70%, rgba(0,0,0,0.85) 100%)",
                }}
              />
            </div>
          </div>

          {/* Copy — overlaps the right portion of the image */}
          <div
            className="relative z-10 md:ml-[44%] lg:ml-[48%] md:pt-12 lg:pt-20 space-y-7 max-w-2xl"
          >
            <p
              className="font-display italic text-white leading-[1.18]"
              style={{ fontSize: "clamp(1.5rem, 2.8vw, 2.4rem)" }}
              data-testid="about-lede"
            >
              ALEKZ is the artist project of Alex Soto, a New York-based creative.
            </p>

            <p className="text-[var(--silver)] text-base leading-relaxed">
              Music has always been the foundation of Alex&apos;s work. What
              began as a deep love for sound has grown into a practice built
              around production, performance, and artist-driven experiences.
            </p>

            <p className="text-[var(--silver-soft)] text-base leading-relaxed">
              Alex is a graduate of NYU with experience across music and
              brand, including time at Platinum Sound Studios under
              Grammy-winning producer Jerry Wonda, as well as creative and
              digital work connected to Converse and Timberland.
            </p>

            <div className="space-y-4">
              <p
                className="text-white text-base leading-relaxed font-medium not-italic"
                data-testid="about-philosophy"
              >
                At the center of Alex&apos;s work is a belief that music still
                does something nothing else can. It gets people out of their
                heads and back into a shared feeling.
              </p>
              <p className="text-[var(--silver-soft)] text-base leading-relaxed">
                As the world becomes faster, more automated, and more
                artificial, Alex stays focused on what cannot be replaced:
                rhythm, emotion, instinct, and connection.
              </p>
              <p className="text-[var(--silver-soft)] text-base leading-relaxed">
                Through his creative endeavors, Alex builds around that
                feeling — creating work that is intentional, immersive, and
                driven by a real love for music.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
